/* =========================================================
   Samlings-broen — mtw-samling-binder.js
   ADDITIVT modul: observerer Byg samling (mtw-samling.js) og
   dekorerer dets DOM med binder-viden fra Mine samlinger.
   Alt fail-soft: fejler noget her, opfører Byg samling sig
   præcis som uden broen.

   Kontakt med motoren (ingen anden):
   - læser resultatkortene: li.mtwc-result[data-handle][data-tile]
     (ét kort pr. udgave; flere kort kan have samme data-handle)
   - køb: window.MTWC.checkoutHandles (motorens lagerkontrol og kurv)
   - "markér som HAR": hændelsen mtwc:added fra motoren

   Backend: App Proxy POST/GET /apps/portal/binders/v2
   ========================================================= */
(function () {
  'use strict';
  if (window.__mtwSbGuard) return;
  window.__mtwSbGuard = true;

  var PROXY = '/apps/portal/binders/v2';
  var BINDERS_URL = '/pages/mine-binders';
  var MAX_ROWS = 200, MAX_CART = 250, DEBOUNCE_MS = 200;

  /* ---------- ikoner (mtw-streg: 2px ink, gule accenter) ---------- */
  var ICON = {
    check: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.5 12.5l5 5L19.5 7" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    binder: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="4" y="3" width="16" height="18" rx="2.5" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2"/><path d="M8.5 3v18" fill="none" stroke="#1a1a1a" stroke-width="2"/><circle cx="8.5" cy="8" r="1.2" fill="#1a1a1a"/><circle cx="8.5" cy="12" r="1.2" fill="#1a1a1a"/><circle cx="8.5" cy="16" r="1.2" fill="#1a1a1a"/><path d="M12 8.5h5M12 12h5M12 15.5h3.2" fill="none" stroke="#1a1a1a" stroke-width="1.6" stroke-linecap="round"/></svg>',
    chev: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9.5l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    cart: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 4.5h2.6l2.1 10.5h10.7l2.1-7.5H7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.6" cy="19.4" r="1.7" fill="currentColor"/><circle cx="16.6" cy="19.4" r="1.7" fill="currentColor"/></svg>'
  };

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtKr(kr) {
    var r = Math.round(kr);
    try { return r.toLocaleString('da-DK') + ' kr'; } catch (e) { return r + ' kr'; }
  }
  function shortTitle(t) { return String(t || '').split(' - ')[0]; }

  function api(payload) {
    return fetch(PROXY, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () { try { boot(); } catch (e) { /* fail-soft */ } });

  function boot() {
    var root = document.querySelector('[data-mtwc-root]');
    // Reglerne (nøgler, lommer, udgave pr. kort, baren) ligger i kernen (mtw-samling-core.js), som indlæses før broen.
    var K = window.MTWCCore;
    if (!root || !K || !K.sbEntry || !('fetch' in window) || !('MutationObserver' in window)) return;
    var host = root.querySelector('[data-mtwc-results]');
    var catscroll = root.querySelector('[data-mtwc-catscroll]') || (host && host.parentNode);
    if (!host || !catscroll) return;

    // Logget ud → gør INGENTING (badges/filter/bar/stempel/progress kræver alle konto).
    var ownScript = document.querySelector('script[data-mtwsb]');
    if (ownScript && !ownScript.getAttribute('data-logged-in')) return;

    /* ---------- state ---------- */
    var myBinders = [];                                  // fra GET — filter-menuen
    var matchState = { sig: '', map: {}, binders: [], masterBinders: null };  // seneste match_produkter-svar
    var filter = { on: false, id: null, navn: '' };
    var handleInfo = {};                                 // handle -> { keys, title } (til stempel-flow)
    var reqSeq = 0, debT = null;
    var barEl = null, barGroup = null, barKey = '', barDismissed = '', ctaBusy = false;
    var progEl = null, filterEl = null, popEl = null, chipLbl = null, chipBtn = null, emptyEl = null;
    var toastEl = null, toastT = null;

    /* ---------- toast (egen — rører ikke motorens) ---------- */
    function toast(html, actions, ms) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'mtwsb-toast';
        toastEl.addEventListener('click', function (e) {
          var xb = e.target.closest ? e.target.closest('[data-mtwsb-tx]') : null;
          if (xb) { hideToast(); return; }
          var ab = e.target.closest ? e.target.closest('[data-mtwsb-act]') : null;
          if (ab) {
            var i = parseInt(ab.getAttribute('data-mtwsb-act'), 10);
            var acts = toastEl.__acts || [];
            hideToast();
            if (acts[i] && typeof acts[i].cb === 'function') { try { acts[i].cb(); } catch (err) {} }
          }
        });
        document.body.appendChild(toastEl);
      }
      var h = '<span class="mtwsb-toast-msg">' + html + '</span>';
      if (actions && actions.length) {
        h += '<span class="mtwsb-toast-acts">';
        for (var i = 0; i < actions.length; i++) {
          var a = actions[i];
          if (a.href) h += '<a class="mtwsb-toast-btn' + (a.primary ? ' mtwsb-toast-btn--pri' : '') + '" href="' + esc(a.href) + '">' + esc(a.label) + '</a>';
          else h += '<button type="button" class="mtwsb-toast-btn' + (a.primary ? ' mtwsb-toast-btn--pri' : '') + '" data-mtwsb-act="' + i + '">' + esc(a.label) + '</button>';
        }
        h += '</span>';
        h += '<button type="button" class="mtwsb-toast-x" data-mtwsb-tx aria-label="Luk">✕</button>';
      }
      toastEl.innerHTML = h;
      toastEl.__acts = actions || [];
      toastEl.classList.add('mtwsb-toast--vis');
      clearTimeout(toastT);
      toastT = setTimeout(hideToast, ms || (actions && actions.length ? 9000 : 3200));
    }
    function hideToast() { if (toastEl) toastEl.classList.remove('mtwsb-toast--vis'); }

    /* ---------- kort-læsning (KUN læsning af motorens DOM) ---------- */
    function getCards() {
      var out = [], ls = host.querySelectorAll('.mtwc-result[data-handle]');
      for (var i = 0; i < ls.length; i++) out.push(ls[i]);
      return out;
    }
    // Produkt-titel = tekstnoder i .mtwc-rname
    function cardTitle(card) {
      var el = card.querySelector('.mtwc-rname');
      if (!el) return '';
      var txt = '', ns = el.childNodes;
      for (var i = 0; i < ns.length; i++) if (ns[i].nodeType === 3) txt += ns[i].nodeValue;
      return txt.replace(/\s+/g, ' ').trim();
    }
    function cardKeys(card) {
      if (card.__mtwsbKeys !== undefined) return card.__mtwsbKeys;
      var t = cardTitle(card), keys = K.sbKeys(t);
      if (keys) {
        var h = card.getAttribute('data-handle');
        if (h) handleInfo[h] = { keys: keys, title: t };
      }
      card.__mtwsbKeys = keys;
      return keys;
    }
    /* Master set: en samling kan have to lommer for samme kort, 'normal' og 'rh' (Reverse Holo).
       Kernen slår op i svaret fra match_produkter ("sæt|nr|udgave"; ældre svar "sæt|nr") og afgør pr. lomme,
       om den er streng (RH-lomme eller master set). Almindelige samlinger opfører sig som før. */
    function lommerForKeys(keys) { return K.sbLommer(matchState.map, keys); }
    function lommerFor(card) { return lommerForKeys(cardKeys(card)); }
    function ctx() { return { masterBinders: matchState.masterBinders, binders: matchState.binders }; }
    // Kortets udgave ud fra motorens data-tile ("Edition|Sprog") via kernens edGroup, aldrig ud fra mærkatens
    // CSS-klasse (.mtwc-badge.rh bruges til ALLE udgaver) eller /reverse/i. Kun Edition-mærkaten præcis "Reverse Holo"
    // er 'rh'; Reverse-Pokeball/Masterball-Holo, Cosmos-, Stamped- og Pokeball-Holo og gradede (PSA/CGC) er 'andre'.
    function tileUd(card) { return K.tileUdgave(card.getAttribute('data-tile') || ''); }
    // Lommen, der hører til netop dette kort (tile): en streng lomme kun på sin rene udgave på engelsk,
    // en almindelig lomme på alle kortets udgaver (som før).
    function entryFor(card) { return K.sbEntry(lommerFor(card), tileUd(card), ctx()); }
    // Pris fra det viste kort: rækken under kortet (.mtwc-rprice) viser den stand, kortet lægger i → "Near Mint · 1.234,50 kr" (da-DK).
    // Motoren retter teksten, når kunden vælger en anden stand på kortet. Uden pris ("Vælg stand", "Udsolgt") giver 0.
    function cardPrice(card) {
      var el = card.querySelector('.mtwc-rprice');
      if (!el) return 0;
      var m = (el.textContent || '').match(/([\d.]+(?:,\d+)?)\s*kr/);
      if (!m) return 0;
      var v = parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
      return isNaN(v) ? 0 : v;
    }
    // Motoren tegner ét kort pr. udgave. Alt, der tælles pr. kort, tælles pr. data-handle:
    // svar [{ handle, tiles: [li, …] }] i den rækkefølge, kortene står i.
    function byHandle(cards) {
      var out = [], at = {};
      for (var i = 0; i < cards.length; i++) {
        var h = cards[i].getAttribute('data-handle');
        if (!h) continue;
        if (!Object.prototype.hasOwnProperty.call(at, h)) { at[h] = out.length; out.push({ handle: h, tiles: [] }); }
        out[at[h]].tiles.push(cards[i]);
      }
      return out;
    }
    // 'ok': et tryk på kortet lægger noget i. 'udenfor': på lager, men kun uden for stand-grænsen. 'udsolgt': intet på lager.
    function tileState(card) {
      if (card.classList.contains('mtwc-result--outside')) return 'udenfor';
      return card.querySelector('.mtwc-soldout-lbl') ? 'udsolgt' : 'ok';
    }

    /* ---------- Feature 1: HAR/MANGLER-badges ---------- */
    function paintBadge(card, hit) {
      var media = card.querySelector('.mtwc-card');
      if (!media) return;
      var b = media.querySelector('.mtwsb-badge');
      if (!hit) { if (b) b.parentNode.removeChild(b); return; }
      var st = (hit.e.har ? 'h' : 'm') + '|' + (hit.e.binder || '');
      if (b && b.__mtwsbState === st) return; // idempotent — ingen DOM-mutation → ingen observer-loop
      if (!b) { b = document.createElement('span'); media.appendChild(b); }
      b.__mtwsbState = st;
      if (hit.e.har) {
        b.className = 'mtwsb-badge mtwsb-badge--har';
        b.innerHTML = ICON.check + 'HAR';
        b.title = 'Du har kortet i “' + (hit.e.binder || 'din binder') + '”';
      } else {
        b.className = 'mtwsb-badge mtwsb-badge--mangler';
        b.textContent = 'MANGLER';
        b.title = 'Mangler i “' + (hit.e.binder || 'din binder') + '”';
      }
    }

    /* ---------- Feature 2: binder-filter (display-only) ---------- */
    function buildFilter() {
      var browse = root.querySelector('[data-mtwc-games]');
      if (!browse || !browse.parentNode) return;
      var usable = [];
      for (var i = 0; i < myBinders.length; i++) if ((myBinders[i].total || 0) > 0) usable.push(myBinders[i]);
      if (!usable.length) return;
      filterEl = document.createElement('div');
      filterEl.className = 'mtwsb-filter';
      var rows = '';
      for (var j = 0; j < usable.length; j++) {
        var b = usable[j], navn = b.navn || b.name || 'Binder';
        var miss = Math.max(0, (b.total || 0) - (b.har || 0));
        rows += '<button type="button" class="mtwsb-poprow" data-mtwsb-pick="' + esc(String(b.id)) + '" data-mtwsb-navn="' + esc(navn) + '">' +
          '<span class="mtwsb-poprow-nm">' + esc(navn) + '</span>' +
          '<span class="mtwsb-poprow-n">' + miss + ' mangler</span></button>';
      }
      filterEl.innerHTML =
        '<button type="button" class="mtwsb-chip" data-mtwsb-menu aria-haspopup="true">' +
          ICON.binder + '<span class="mtwsb-chip-lbl" data-mtwsb-chiplbl>Mine samlinger</span>' +
          '<span class="mtwsb-chip-ic">' + ICON.chev + '</span>' +
        '</button>' +
        '<div class="mtwsb-pop" data-mtwsb-pop hidden>' +
          '<div class="mtwsb-pop-t">Vis kun kort du mangler i …</div>' + rows +
          '<a class="mtwsb-pop-link" href="' + BINDERS_URL + '">Åbn Mine samlinger →</a>' +
        '</div>';
      browse.insertAdjacentElement('afterend', filterEl);
      popEl = filterEl.querySelector('[data-mtwsb-pop]');
      chipBtn = filterEl.querySelector('[data-mtwsb-menu]');
      chipLbl = filterEl.querySelector('[data-mtwsb-chiplbl]');

      filterEl.addEventListener('click', function (e) {
        var clr = e.target.closest ? e.target.closest('[data-mtwsb-clear]') : null;
        if (clr) { e.stopPropagation(); setFilter(null, ''); return; }
        var pick = e.target.closest ? e.target.closest('[data-mtwsb-pick]') : null;
        if (pick) { setFilter(pick.getAttribute('data-mtwsb-pick'), pick.getAttribute('data-mtwsb-navn') || ''); return; }
        if (e.target.closest && e.target.closest('[data-mtwsb-menu]')) { popEl.hidden = !popEl.hidden; return; }
      });
      document.addEventListener('click', function (e) {
        if (popEl && !popEl.hidden && filterEl && !filterEl.contains(e.target)) popEl.hidden = true;
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popEl && !popEl.hidden) popEl.hidden = true;
      });
    }
    /* Søgeord for binderen: sæt-binders hedder sættet; pokemon/artist bruger
       skabelon-nøglen. Custom binders har intet naturligt søgeord (null). */
    function soegeordFor(id) {
      for (var i = 0; i < myBinders.length; i++) {
        var b = myBinders[i];
        if (String(b.id) === String(id)) {
          var t = b.template || {};
          if (t.type === 'set') return b.name;
          if (t.type === 'pokemon' || t.type === 'artist') return t.key || b.name;
          return null;
        }
      }
      return null;
    }
    /* Antal manglende kort i binderen (total - har), 0 hvis den ikke findes. */
    function manglerI(id) {
      for (var i = 0; i < myBinders.length; i++) {
        if (String(myBinders[i].id) === String(id)) return Math.max(0, (myBinders[i].total || 0) - (myBinders[i].har || 0));
      }
      return 0;
    }
    /* Vælges en binder, skal visningen SELV hente kortene — vi driver motorens
       egen søgning (input-event; ALDRIG Enter, som ville tilføje øverste kort).
       Motorens re-render trigger vores observer, som badger + filtrerer. */
    function drivSoegning(id) {
      try {
        var inp = document.querySelector('[data-mtwc-input]');
        var ord = soegeordFor(id);
        if (!inp || !ord) return;
        inp.value = ord;
        inp.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e) { /* fail-soft: filteret virker stadig på nuværende visning */ }
    }

    function setFilter(id, navn) {
      filter.on = id != null && id !== '';
      filter.id = filter.on ? id : null;
      filter.navn = filter.on ? navn : '';
      if (filter.on) drivSoegning(id);
      if (chipBtn && chipLbl) {
        if (filter.on) {
          chipBtn.classList.add('mtwsb-chip--on');
          chipLbl.innerHTML = esc(navn) + ' · kun mangler' +
            '<span class="mtwsb-chip-x" data-mtwsb-clear role="button" aria-label="Ryd filter">✕</span>';
        } else {
          chipBtn.classList.remove('mtwsb-chip--on');
          chipLbl.textContent = 'Mine samlinger';
        }
      }
      if (popEl) {
        popEl.hidden = true;
        var rws = popEl.querySelectorAll('[data-mtwsb-pick]');
        for (var i = 0; i < rws.length; i++) {
          rws[i].classList.toggle('mtwsb-poprow--on', filter.on && rws[i].getAttribute('data-mtwsb-pick') === String(filter.id));
        }
      }
      barDismissed = '';
      apply();
    }
    /* Direkte link med mangler=1 (motoren: window.MTWC.direkte). Kaldes én gang, når filteret er bygget, og i overlayet ved
       hver åbning (hændelsen mtwc:aabnet med konteksten som d; før filteret er bygget, gør den intet).
       Åbnede linket forsiden, og har præcis én af binderne i menuen et søgeord og manglende kort, vælges den straks ("kun mangler").
       Ellers åbnes menuen, så kunden selv vælger. Det sker uden for et klik, så "klik udenfor lukker" rammer den ikke. */
    function direkteMangler(d) {
      try {
        d = d || (window.MTWC && window.MTWC.direkte);
        if (!d || !d.mangler || !popEl) return;
        var rws = popEl.querySelectorAll('[data-mtwsb-pick]'), med = [];
        for (var i = 0; i < rws.length; i++) {
          var id = rws[i].getAttribute('data-mtwsb-pick');
          if (soegeordFor(id) != null && manglerI(id) > 0) med.push(rws[i]);
        }
        if (d.mode === 'forside' && med.length === 1) { setFilter(med[0].getAttribute('data-mtwsb-pick'), med[0].getAttribute('data-mtwsb-navn') || ''); return; }
        if (rws.length) popEl.hidden = false;
      } catch (e) { /* fail-soft: værktøjet er åbnet som uden mangler=1 */ }
    }
    function ensureEmptyHint() {
      if (emptyEl) return emptyEl;
      emptyEl = document.createElement('div');
      emptyEl.className = 'mtwsb-empty';
      emptyEl.hidden = true;
      emptyEl.innerHTML = '<span data-mtwsb-emptytxt></span> <button type="button" class="mtwsb-empty-clear" data-mtwsb-emptyclear>Vis alle kort</button>';
      catscroll.insertBefore(emptyEl, host);
      emptyEl.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-mtwsb-emptyclear]')) setFilter(null, '');
      });
      return emptyEl;
    }

    /* ---------- Feature 3: mangler-bar + "Læg alle i kurven" ---------- */
    function buildBar() {
      barEl = document.createElement('div');
      barEl.className = 'mtwsb-bar';
      barEl.hidden = true;
      barEl.innerHTML =
        '<span class="mtwsb-bar-txt" data-mtwsb-bartxt></span>' +
        '<button type="button" class="mtwsb-bar-cta" data-mtwsb-addall></button>' +
        '<button type="button" class="mtwsb-bar-x" data-mtwsb-barx aria-label="Skjul">✕</button>';
      catscroll.appendChild(barEl);
      barEl.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-mtwsb-addall]')) { addAll(); return; }
        if (e.target.closest && e.target.closest('[data-mtwsb-barx]')) { barDismissed = barKey; barEl.hidden = true; }
      });
    }
    // "Læg alle i kurven" køber kun den almindelige udgave i den stand, kortet viser som valgt: inden for stand-grænsen,
    // eller den stand, kunden selv har valgt på kortet (motorens regel). Baren tæller derfor:
    //   items   : kort, hvis almindelige udgave kan lægges i (antal, sum og kurv)
    //   anden   : kun en anden udgave (fx Reverse Holo) kan lægges i; kunden vælger den selv på kortet
    //   udenfor : på lager, men kun uden for stand-grænsen
    //   udsolgt : ingen af de viste udgaver kan lægges i
    // Strenge lommer (RH-lommer og lommer i master sets): hver manglende lomme købes i sin egen udgave,
    // kort-lommen som Normal og RH-lommen som Reverse Holo (engelsk). Andre udgaver tælles aldrig med, og en lomme,
    // hvis udgave ikke er vist, springes over. Reglerne står i kernen (sbBarGroups); her læses kun DOM'en og skrives teksten.
    function updateBar(cards) {
      if (!barEl) return;
      var per = byHandle(cards), rows = [], i;
      for (i = 0; i < per.length; i++) {
        rows.push({
          handle: per[i].handle,
          l: lommerFor(per[i].tiles[0]),
          tiles: per[i].tiles.map(function (t) {
            var u = tileUd(t);
            return { udgave: u.udgave, engelsk: u.engelsk, state: tileState(t), hidden: t.classList.contains('mtwsb-hide'), price: cardPrice(t) };
          })
        });
      }
      var res = K.sbBarGroups(rows, ctx()), groups = res.groups, order = res.order;
      var top = null;
      if (filter.on) top = groups[String(filter.id)] || null;
      else {
        for (i = 0; i < order.length; i++) if (!top || groups[order[i]].items.length > top.items.length) top = groups[order[i]];
        if (top && top.items.length < 3) top = null;
      }
      var rest = top ? top.udsolgt + top.udenfor + top.anden : 0;
      if (!top || (!top.items.length && !rest)) { barEl.hidden = true; barGroup = null; return; }
      barKey = String(top.id) + '::' + matchState.sig;
      if (barDismissed === barKey) { barEl.hidden = true; barGroup = null; return; }
      barGroup = top;
      var sum = 0, n = top.items.length;
      for (i = 0; i < n; i++) sum += top.items[i].price;
      var cta = barEl.querySelector('[data-mtwsb-addall]');
      var dele = [];
      if (top.udenfor > 0) dele.push(top.udenfor + ' uden for din stand-grænse');
      if (top.anden > 0) dele.push(top.anden + ' kun i en anden udgave');
      if (top.udsolgt > 0) dele.push(top.udsolgt + (n > 0 ? ' er udsolgt' : ' udsolgt'));
      if (n > 0) {
        if (top.master) {
          // Master set: "14 af dine manglende kort … · 8 kort og 6 Reverse Holo"
          var nRh = 0;
          for (i = 0; i < n; i++) if (top.items[i].udgave === 'rh') nRh++;
          var fordeling = [];
          if (n - nRh > 0) fordeling.push((n - nRh) + ' kort');
          if (nRh > 0) fordeling.push(nRh + ' Reverse Holo');
          barEl.querySelector('[data-mtwsb-bartxt]').innerHTML =
            '<b>' + n + '</b> af dine manglende kort fra “' + esc(top.navn) + '” er på lager her · ' + fordeling.join(' og ') +
            (sum > 0 ? ' · samlet <b>' + fmtKr(sum) + '</b>' : '') +
            (dele.length ? ' <span class="mtwsb-bar-dim">· ' + dele.join(' · ') + '</span>' : '');
        } else {
          barEl.querySelector('[data-mtwsb-bartxt]').innerHTML =
            '<b>' + n + '</b> af dine mangler fra “' + esc(top.navn) + '” er på lager her' +
            (sum > 0 ? ' — samlet <b>' + fmtKr(sum) + '</b>' : '') +
            (dele.length ? ' <span class="mtwsb-bar-dim">· ' + dele.join(' · ') + '</span>' : '');
        }
        if (!ctaBusy) {
          cta.disabled = false;
          cta.hidden = false;
          cta.innerHTML = ICON.cart + '<span>Læg alle i kurven' + (n > MAX_CART ? ' (' + MAX_CART + ')' : '') + '</span>';
        }
      } else {
        // Intet kan købes herfra: informér ærligt — ingen kurv-CTA at tilbyde
        barEl.querySelector('[data-mtwsb-bartxt]').innerHTML = rest === top.udsolgt
          ? 'Alle <b>' + top.udsolgt + '</b> af dine mangler fra “' + esc(top.navn) + '” her er udsolgt lige nu'
          : 'Ingen af dine <b>' + rest + '</b> mangler fra “' + esc(top.navn) + '” kan lægges i herfra: ' + dele.join(' · ');
        cta.hidden = true;
      }
      barEl.hidden = false;
    }
    // Køb går gennem motoren (window.MTWC.checkoutHandles): frisk lagerkontrol, kun den almindelige udgave i den stand,
    // kortet viser som valgt, og intet lægges i kurven to gange. Broen har ingen kurv-logik selv.
    // rep.unchecked: kort, motoren ikke kunne slå op (butikken svarede ikke). De er ikke udsolgt og ikke lagt i:
    // de får deres egen tekst og tilbydes ikke stempling.
    // rep.changed: kort, hvor de friske data giver en anden stand end den, kortet viste ved trykket. Motoren har ikke lagt dem i
    // og tegner kortene igen; de får deres egen tekst og tilbydes ikke stempling.
    function addAll() {
      if (!barGroup || ctaBusy) return;
      var items = barGroup.items.slice(0, MAX_CART);
      var navn = barGroup.navn;
      var cta = barEl.querySelector('[data-mtwsb-addall]');
      ctaBusy = true;
      cta.disabled = true;
      function resetCta() { ctaBusy = false; cta.disabled = false; updateBar(getCards()); }
      if (!window.MTWC || !window.MTWC.checkoutHandles) { resetCta(); toast('Kort-vælgeren er ikke klar. Genindlæs siden.'); return; }
      cta.textContent = 'Lægger i kurven …';
      // Master set: Reverse Holo-lommer køber Reverse Holo-kortet (motoren melder dem tilbage som 'rh:' + handle).
      var normale = [], rhs = [];
      items.forEach(function (it) { (it.udgave === 'rh' ? rhs : normale).push(it.handle); });
      window.MTWC.checkoutHandles(normale, rhs).then(function (rep) {
        resetCta();
        var utjekket = rep.unchecked || [], aendret = rep.changed || [];
        var lagt = K.sbLagt(items, rep, rhs.length > 0);
        // rep.blind: kurven kunne ikke læses efter et fejlet kald, så kort i rep.left kan ligge i kurven. Sig kun det, vi ved.
        var tekst = (rep.blind ? (rep.added ? 'Mindst ' + rep.added + ' af dine mangler lagt i kurven' : 'Vi fik ikke svar fra kurven')
            : (rep.added ? rep.added + ' af dine mangler lagt i kurven' : 'Ingen kort blev lagt i kurven')) +
          (rep.already ? ' · ' + rep.already + ' lå der allerede' : '') +
          (rep.outside.length ? ' · ' + rep.outside.length + ' er udsolgt eller uden for din stand-grænse' : '') +
          (rep.blind ? ' · Vi ved ikke, om alle kort kom i kurven. Tryk igen. Intet lægges i to gange.'
            : rep.left.length ? ' · ' + rep.left.length + ' kunne ikke lægges i' : '') +
          (aendret.length ? ' · ' + aendret.length + ' har ændret stand eller pris. Se kortene og prøv igen.' : '') +
          (utjekket.length ? ' · ' + utjekket.length + ' kunne ikke tjekkes. Prøv igen om lidt.' : '');
        toast(tekst, lagt.length ? [
          { label: 'Se kurv', href: '/cart' },
          { label: 'Markér som HAR', primary: true, cb: function () { stampMany(lagt, navn); } }
        ] : [], 12000);
      }, function (err) {
        resetCta();
        // 'anden-fane': en anden fane lægger i kurven lige nu. 'optaget': motoren er selv i gang. I begge tilfælde har dette tryk intet sendt.
        var hvorfor = err && err.message;
        toast(hvorfor === 'anden-fane' ? 'En anden fane lægger i kurven lige nu. Prøv igen om et øjeblik.'
          : hvorfor === 'optaget' ? 'Kunne ikke lægge i kurven. Intet er lagt i. Prøv igen.' : 'Noget gik galt. Prøv igen. Intet lægges i kurven to gange.');
      });
    }

    /* ---------- Feature 4: stempl ved køb (altid eksplicit opt-in) ---------- */
    function stampOne(entry) {
      api({ action: 'toggle', binder_id: entry.binder_id, slot_id: entry.slot_id, har: true })
        .then(function (d) {
          if (d && d.ok) {
            entry.har = true;
            apply();
            toast('Stemplet som HAR i “' + esc(entry.binder || 'din binder') + '” ✓');
          } else toast('Kunne ikke stemple — prøv igen');
        })
        .catch(function () { toast('Kunne ikke stemple — prøv igen'); });
    }
    function stampMany(entries, navn) {
      var i = 0, ok = 0;
      function step() {
        if (i >= entries.length) {
          if (ok) { apply(); toast('Stemplet ' + ok + ' kort som HAR i “' + esc(navn) + '” ✓'); }
          else toast('Kunne ikke stemple — prøv igen fra Mine samlinger');
          return;
        }
        var e = entries[i++];
        if (!e || e.har) { step(); return; }
        api({ action: 'toggle', binder_id: e.binder_id, slot_id: e.slot_id, har: true })
          .then(function (d) { if (d && d.ok) { e.har = true; ok++; } step(); })
          .catch(function () { step(); });
      }
      step();
    }
    function offerStamp(entry, title) {
      toast('I binderen ✓ — markér <b>' + esc(shortTitle(title)) + '</b> som HAR i “' + esc(entry.binder || 'din binder') + '”?', [
        { label: 'Ja, markér som HAR', primary: true, cb: function () { stampOne(entry); } },
        { label: 'Ikke nu', cb: function () {} }
      ], 9000);
    }
    // Motoren melder selv, når et kort faktisk er lagt i dens binder (klik eller Enter; også når antallet stiger).
    // e.detail = { handle, title, variantId }. Står kortet som MANGLER, tilbydes stempling.
    document.addEventListener('mtwc:added', function (e) {
      try {
        var d = e && e.detail, info = d && typeof d.handle === 'string' ? handleInfo[d.handle] : null;
        if (!info) return;
        // Lommen følger den udgave, der blev lagt i binderen. En streng lomme kræver ren Normal/Reverse Holo på engelsk
        // (ukendt udgave → intet tilbud; mangler sproget, regnes engelsk). En almindelig lomme gælder alle udgaver (som før).
        var u = d.ed ? K.tileUdgave(d.ed + '|' + (d.lang || 'English')) : null;
        var entry = K.sbEntry(lommerForKeys(info.keys), u, ctx());
        entry = entry && entry.e;
        if (!entry || entry.har) return;
        offerStamp(entry, info.title);
      } catch (err) {}
    });

    /* ---------- Feature 5: sæt-progress ---------- */
    function buildProgress() {
      progEl = document.createElement('div');
      progEl.className = 'mtwsb-progress';
      progEl.hidden = true;
      progEl.innerHTML =
        '<div class="mtwsb-progress-head">' +
          '<span class="mtwsb-progress-ic">' + ICON.binder + '</span>' +
          '<span class="mtwsb-progress-nm" data-mtwsb-pnm></span>' +
          '<span class="mtwsb-progress-meta" data-mtwsb-pmeta></span>' +
          '<a class="mtwsb-progress-link" href="' + BINDERS_URL + '">Åbn binder →</a>' +
        '</div>' +
        '<div class="mtwsb-progress-track"><i class="mtwsb-progress-fill" data-mtwsb-pfill></i></div>';
      catscroll.insertBefore(progEl, host);
    }
    function updateProgress(cards) {
      if (!progEl) return;
      // Sæt-kontekst: motorens "Browse sæt"-mode viser collector-numre (.mtwc-cardno)
      var setMode = !!host.querySelector('.mtwc-cardno');
      if (!setMode || !matchState.binders || !matchState.binders.length) { progEl.hidden = true; return; }
      var tally = {}, topId = null, i, per = byHandle(cards);
      for (i = 0; i < per.length; i++) {
        var lp = lommerFor(per[i].tiles[0]), hit = lp ? (lp.normal || lp.rh) : null;
        if (!hit) continue;
        var gid = String(hit.e.binder_id);
        tally[gid] = (tally[gid] || 0) + 1;
        if (topId === null || tally[gid] > tally[topId]) topId = gid;
      }
      if (topId === null) { progEl.hidden = true; return; }
      var b = null;
      for (i = 0; i < matchState.binders.length; i++) {
        if (String(matchState.binders[i].id) === topId) { b = matchState.binders[i]; break; }
      }
      var total = b ? (b.total || 0) : 0;
      if (!b || total < 10) { progEl.hidden = true; return; }
      var har = b.har || 0;
      var pct = Math.max(0, Math.min(100, Math.round((har / total) * 100)));
      progEl.querySelector('[data-mtwsb-pnm]').textContent = b.navn || b.name || 'Din binder';
      progEl.querySelector('[data-mtwsb-pmeta]').textContent = har + ' af ' + total + ' · ' + pct + ' %';
      progEl.querySelector('[data-mtwsb-pfill]').style.width = pct + '%';
      progEl.hidden = false;
    }

    /* ---------- apply: dekorér + filtrér + bar + progress ---------- */
    function apply() {
      var cards = getCards(), i, visible = 0;
      for (i = 0; i < cards.length; i++) {
        var card = cards[i];
        var hit = entryFor(card);
        paintBadge(card, hit);
        if (filter.on) {
          var keep = !!(hit && !hit.e.har && String(hit.e.binder_id) === String(filter.id));
          card.classList.toggle('mtwsb-hide', !keep);
          if (keep) visible++;
        } else {
          if (card.classList.contains('mtwsb-hide')) card.classList.remove('mtwsb-hide');
          visible++;
        }
      }
      var eh = ensureEmptyHint();
      if (filter.on && cards.length && !visible) {
        eh.querySelector('[data-mtwsb-emptytxt]').textContent =
          'Ingen af dine mangler fra “' + filter.navn + '” er i denne visning.';
        eh.hidden = false;
      } else eh.hidden = true;
      updateBar(cards);
      updateProgress(cards);
    }

    /* ---------- scan: parse titler → batch match ---------- */
    function scan() {
      var cards = getCards(), uniq = {}, sigArr = [], i, j;
      for (i = 0; i < cards.length; i++) {
        var keys = cardKeys(cards[i]);
        if (!keys) continue;
        for (j = 0; j < keys.length; j++) {
          if (!uniq[keys[j]]) { uniq[keys[j]] = 1; sigArr.push(keys[j]); }
        }
      }
      var sig = sigArr.slice().sort().join(',');
      if (!sig || sig === matchState.sig) { apply(); return; }
      apply(); // dekorér straks med det vi allerede ved
      var rows = [];
      for (i = 0; i < sigArr.length && rows.length < MAX_ROWS; i++) {
        var parts = sigArr[i].split('|');
        rows.push({ set: parts[0], number: parts.slice(1).join('|') });
      }
      var seq = ++reqSeq;
      api({ action: 'match_produkter', rows: rows })
        .then(function (d) {
          if (seq !== reqSeq || !d || typeof d !== 'object') return;
          matchState.sig = sig;
          matchState.map = d.match || {};
          matchState.binders = d.binders || [];
          matchState.masterBinders = Array.isArray(d.masterBinders) ? d.masterBinders : null;
          apply();
        })
        .catch(function () { /* 401/net → stille; motoren kører videre urørt */ });
    }
    function scanSafe() { try { scan(); } catch (e) {} }

    /* ---------- init: kun aktiv når kunden har binders ---------- */
    // Overlayet: en åbning uden mangler rydder et "kun mangler"-filter fra en tidligere åbning (uden at køre en søgning),
    // så kunden ser præcis det, indgangen lovede. Ved luk fjernes broens besked og menu fra siden bag.
    document.addEventListener('mtwc:aabnet', function (e) {
      var d = e && e.detail;
      if (filter.on && !(d && d.mangler)) setFilter(null, '');
      direkteMangler(d);
    });
    document.addEventListener('mtwc:lukket', function () {
      hideToast();
      if (popEl) popEl.hidden = true;
    });
    fetch(PROXY, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (d) {
        var bs = (d && d.binders) || [];
        if (!bs.length) return; // ingen binders → modulet forbliver helt passivt
        myBinders = bs;
        buildFilter();
        buildProgress();
        buildBar();
        var mo = new MutationObserver(function () {
          clearTimeout(debT);
          debT = setTimeout(scanSafe, DEBOUNCE_MS);
        });
        mo.observe(host, { childList: true, subtree: true });
        scanSafe();
        direkteMangler();
      })
      .catch(function () { /* logget ud / proxy nede → gør ingenting */ });
  }
})();
